import { BulkAction, RowSelectionState } from 'design-system-web';
import React from 'react';
import { BulkStatusUpdateAction } from './BulkStatusUpdateAction';
import { BulkTeamsAssignAction } from './BulkTeamsAssignAction';
import { BulkAssigneeAction } from './BulkAssigneeAction';
import { AdminUser } from 'packages/lane-shared/domains/workOrder/hooks/useAssignableMembers';
import { useSpaceOpsPmBulkActionsEnabled } from 'react-hooks';

type BulkActionsOptions = {
    assignableTeams?: AdminUser[];
    assignableUsers?: AdminUser[];
    refetch?: () => void;
};

export function useGetBulkActionsForTasks(
    options: BulkActionsOptions = {}
): BulkAction[] {
    const isSpaceOpsPmBulkActionsEnabled = useSpaceOpsPmBulkActionsEnabled();
    const { assignableTeams = [], assignableUsers = [], refetch } = options;

    const bulkActions: BulkAction[] = [];

    if (isSpaceOpsPmBulkActionsEnabled) { // Status update action
        bulkActions.push({
            renderAction: (rowSelection?: RowSelectionState) => {
                return React.createElement(BulkStatusUpdateAction, { rowSelection, refetch });
            },
        });

        // Teams assign action
        if (assignableTeams.length > 0) {
            bulkActions.push({
                renderAction: (rowSelection?: RowSelectionState) => {
                    return React.createElement(BulkTeamsAssignAction, {
                        rowSelection,
                        assignableTeams,
                        refetch,
                    });
                },
            });
        }

        // Member assign action
        if (assignableUsers.length > 0) {
            bulkActions.push({
                renderAction: (rowSelection?: RowSelectionState) => {
                    return React.createElement(BulkAssigneeAction, {
                        rowSelection,
                        assignableUsers,
                        refetch,
                    });
                },
            });
        }
    }

    return bulkActions;
}
